<script setup lang="ts">
interface Props {
    disabled?: boolean
    hideTitle?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false,
    hideTitle: false,
})

const value = defineModel<boolean>()
const emit = defineEmits<{submit: []}>()

const submit = () => {
    value.value = false
    emit('submit')
}
</script>

<template>
    <v-dialog
        v-model="value"
        max-width="800"
        scrim="blue-grey-darken-4"
        opacity="0.5"
        transition="dialog-top-transition"
    >
        <template #default>
            <v-card
                class="pa-1"
                rounded="lg"
            >
                <v-card-title
                    v-if="!props.hideTitle"
                    class="font-weight-bold"
                >
                    <slot name="title">
                        Are you sure you want to proceed?
                    </slot>
                    <v-btn
                        :icon="true"
                        color="base"
                        variant="plain"
                        rounded="lg"
                        class="float-end"
                        size="32"
                        @click="value = false"
                    >
                        <v-icon size="20">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="text-body-2 px-4">
                    <slot />
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer />
                    <v-btn
                        color="white"
                        variant="flat"
                        border="sm"
                        type="button"
                        @click="value = false"
                    >
                        <span class="font-weight-regular">
                            Cancel
                        </span>
                    </v-btn>
                    <v-btn
                        color="primary"
                        variant="flat"
                        border="sm"
                        :disabled="props.disabled"
                        @click="submit"
                    >
                        <span class="font-weight-regular">
                            <slot name="label">Yes, confirm it</slot>
                        </span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

<style scoped>

</style>
